import React, { useCallback, memo } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { openLayerTray, setOverlapHoverLayer } from '@actions/map-actions';
import LayerListItem from '@shared/new-list-item/layer-list-item';

const Layer = ({ id, type, ...otherProps }) => {
  const dispatch = useDispatch();

  const handleClick = useCallback(() => {
    const trayProps = {
      id,
      type
    };
    dispatch(openLayerTray(trayProps));
  }, [dispatch, id, type]);

  const handleMouseEnter = useCallback(() => {
    dispatch(setOverlapHoverLayer({ id, type, ...otherProps }));
  }, [dispatch, id, type, otherProps]);

  const handleMouseLeave = useCallback(() => {
    dispatch(setOverlapHoverLayer());
  }, [dispatch]);

  // LayerListItem expects onClick to be called with (type, id, segments)
  // but we override it completely
  const dummyOnClick = useCallback(() => {}, []);

  return (
    <LayerListItem
      {...otherProps}
      id={id}
      onClick={dummyOnClick}
      customOnClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    />
  );
};

Layer.propTypes = {
  id: PropTypes.number,
  type: PropTypes.string
};

export default memo(Layer);
